export function getActionDeniedTemplate(accessDeniedTranslations, templateKey = 'action_denied') {
  return (
    accessDeniedTranslations?.[templateKey] ??
    accessDeniedTranslations?.action_denied ??
    "You don't have permission to perform this action. Please contact your organization admin ({email})."
  );
}

export function formatAccessDeniedMessage(template, email = '') {
  if (!template) {
    return '';
  }
  return template.replace('{email}', email.trim());
}